import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { GridLineIcon, ListCheckLineIcon, type SegmentedOptions } from 'ui';
import type { Layout } from '../../../../types';

export const useGetLayoutOptions = (): SegmentedOptions<Layout> => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      { icon: <GridLineIcon size="extra-small" />, tooltip: { title: t('Calendar') }, value: 'calendar' },
      { icon: <ListCheckLineIcon size="extra-small" />, tooltip: { title: t('Agenda') }, value: 'agenda' },
    ],
    [t],
  );
};
